import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { area_id: areaId } = url.parseQuerystring()
  return areaId
}

export const getAreaId = userInfo => {
  if (userInfo.areaId) {
    return userInfo.areaId
  } else if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  } else {
    return getCookie('mc_loguser_area')
  }
}
